<template>
    <div class="details_body">
        <ul class="details_tab">
            <li @click="num = 0" :class="{active: num == 0}">说明</li>
        </ul>
        <div class="details_gn" v-show="num == 0">
            <p class="tent">
                1.其他支付金额用于购买产品时非常规金额支付。
            </p>
            <p class="tent">
                2.支付前请拨打400-811-3366与客服人员确认所购买的产品与金额。
            </p>
            <p class="tent">
                3.如未与客服人员确认相关信息，恕无法处理。
            </p>
            <div class="tips">安全提示：交易过程中请勿点击不明来源的链接，付款前请务必详细核对支付信息</div>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                num: 0
            }
        },
    }
</script>
<style scoped src='./doc.css'></style>